import React from 'react'
import Footer from './Footer';
import "./Faq.css"

function Faq() {
  return (
    <div>
      <div className="faq" id="faq" style={{ background: "#37517e" }}>
        <p className="faq__title">Faq</p>

        <details class="accordion">
          <summary class="accordion-btn">
            {" "}
            Why should I share my website online?
          </summary>
          <div class="accordion-content">
            <p>
              Sharing your website online increases its visibility, making it
              accessible to a wider audience. It can attract potential
              customers, increase brand awareness, and generate leads.
            </p>
          </div>
        </details>

        <details class="accordion">
          <summary class="accordion-btn">
            What are the benefits of sharing my website on forums and
            communities?
          </summary>
          <div class="accordion-content">
            <p>
              Sharing on forums and communities can establish credibility, build
              relationships with potential customers, and drive targeted traffic
              to your website if you engage meaningfully and provide valuable
              content.
            </p>
          </div>
        </details>

        <details class="accordion">
          <summary class="accordion-btn">
            How can I track the impact of sharing my website online?
          </summary>
          <div class="accordion-content">
            <p>
              Utilizing web analytics tools like Google Analytics can help track
              website traffic, user behavior, referral sources, and conversion
              rates. This data can provide insights into the effectiveness of
              your sharing strategies.
            </p>
          </div>
        </details>

        <details class="accordion">
          <summary class="accordion-btn">
            Can I optimize my website for better sharing?
          </summary>
          <div class="accordion-content">
            <p>
              Yes, you can optimize your website by adding social sharing
              buttons, creating shareable content, optimizing meta tags for
              social media, and ensuring your site is mobile-friendly to enhance
              the sharing experience.
            </p>
          </div>
        </details>
      </div>
      <Footer/>
    </div>
  );
}

export default Faq